import type { AxiosInstance } from 'axios';
import type { ModelConfiguration } from '@/models/modelConfigurations';
import type { ChatItem } from '@/types/apiTypes';
import type { Doc, Message } from '@/types/sharedTypes';
import buildMessage from './buildMessage';
import cleanEmptyResponseMessages from './cleanEmptyResponseMessages';

const buildMessages = async (
  api: AxiosInstance,
  model_config: ModelConfiguration,
  prompt: string,
  docs: Doc[],
  chat_history: ChatItem[],
  image_url?: string,
): Promise<Message[]> => {
  const message = await buildMessage(
    api,
    model_config,
    prompt,
    docs,
    image_url,
  );

  const messages: Message[] = [message];

  if (chat_history?.length) {
    let used_tokens = message.content_tokens;
    const clean_history = cleanEmptyResponseMessages(chat_history);
    for (
      let pair_index = clean_history.length / 2 - 1;
      pair_index >= 0;
      pair_index--
    ) {
      const question = clean_history[pair_index * 2];
      const answer = clean_history[pair_index * 2 + 1];

      const chat_pair_length =
        model_config.chat_pair_tokens +
        (question.content_tokens || 0) +
        (answer.content_tokens || 0);
      if (chat_pair_length + used_tokens > model_config.max_input_length) {
        break;
      } else {
        // Convert ChatItem to Message format
        const questionMessage: Message = {
          role: question.role,
          content: question.content,
          content_tokens: question.content_tokens || 0,
        };
        const answerMessage: Message = {
          role: answer.role,
          content: answer.content,
          content_tokens: answer.content_tokens || 0,
        };
        messages.unshift(answerMessage);
        messages.unshift(questionMessage);
        used_tokens += chat_pair_length;
      }
    }
  }

  return messages;
};
export default buildMessages;

